module.exports = {
      id: "ic-xlmusd-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-xlmusd-usage",
      toString: function () {
        return this.url;
      }
    }